import React, { FC } from 'react'
import Page from '../../components/Page/Page'
import WelcomeHeader from './WelcomeHeader/WelcomeHeader'
import { WelcomeFooter } from './styled'
import { BodyWelcome } from './WelcomeBody/styled'

interface WelcomeLayoutProps {
	children?: React.ReactNode
}

const WelcomeLayout: FC<WelcomeLayoutProps> = ({
	children,
}: WelcomeLayoutProps) => {
	return (
		<Page>
			<WelcomeHeader />

			<BodyWelcome>{children}</BodyWelcome>

			<WelcomeFooter>
				<p>Call us toll free:</p>

				<a href={'tel: 1-833-914-3798'}>1-833-914-3798</a>
			</WelcomeFooter>
		</Page>
	)
}

export default WelcomeLayout
